import * as React from 'react';
import useCurrentUser from '../../../hooks/useCurrentUser';
import { Select } from '@moovly/ui';

interface UserGroupFilterProps {
  selectedGroup: null | string;
  onChange: (group: string | null) => void;
}

const UserGroupFilter: React.FC<UserGroupFilterProps> = ({ selectedGroup, onChange }) => {
  const { groupsWithAdminRight } = useCurrentUser();
  const options = React.useMemo(
    () => [{ value: null, label: 'All' }, ...groupsWithAdminRight.map((gr) => ({ value: gr.id, label: gr.name }))],
    [groupsWithAdminRight]
  );
  const handleGroupSelect = React.useCallback(
    ({ value }: { value: string | null }) => {
      onChange(value);
    },
    [onChange]
  );
  const value = React.useMemo(() => options.find((o) => o.value === selectedGroup), [selectedGroup, options]);
  if (groupsWithAdminRight.length <= 1) {
    return null;
  }
  return (
    <div style={{ minWidth: 200 }}>
      <Select options={options} value={value} onChange={handleGroupSelect} />
    </div>
  );
};

export default UserGroupFilter;
